import { IDomain } from '../../types';

// Action Types
export const GET_DOMAINS_REQUEST = 'GET_DOMAINS_REQUEST';
export const GET_DOMAINS_SUCCESS = 'GET_DOMAINS_SUCCESS';
export const GET_DOMAINS_FAILURE = 'GET_DOMAINS_FAILURE';

export const CREATE_DOMAIN_REQUEST = 'CREATE_DOMAIN_REQUEST';
export const CREATE_DOMAIN_SUCCESS = 'CREATE_DOMAIN_SUCCESS';
export const CREATE_DOMAIN_FAILURE = 'CREATE_DOMAIN_FAILURE';

export const GET_DOMAIN_REQUEST = 'GET_DOMAIN_REQUEST';
export const GET_DOMAIN_SUCCESS = 'GET_DOMAIN_SUCCESS';
export const GET_DOMAIN_FAILURE = 'GET_DOMAIN_FAILURE';

export const VERIFY_DOMAIN_REQUEST = 'VERIFY_DOMAIN_REQUEST';
export const VERIFY_DOMAIN_SUCCESS = 'VERIFY_DOMAIN_SUCCESS';
export const VERIFY_DOMAIN_FAILURE = 'VERIFY_DOMAIN_FAILURE';

export const DELETE_DOMAIN_REQUEST = 'DELETE_DOMAIN_REQUEST';
export const DELETE_DOMAIN_SUCCESS = 'DELETE_DOMAIN_SUCCESS';
export const DELETE_DOMAIN_FAILURE = 'DELETE_DOMAIN_FAILURE';

export const CLEAR_DOMAIN_STATE = 'CLEAR_DOMAIN_STATE';

// Action Interfaces
export interface GetDomainsRequestAction {
  type: typeof GET_DOMAINS_REQUEST;
}

export interface GetDomainsSuccessAction {
  type: typeof GET_DOMAINS_SUCCESS;
  payload: IDomain[];
}

export interface GetDomainsFailureAction {
  type: typeof GET_DOMAINS_FAILURE;
  payload: string;
}

export interface CreateDomainRequestAction {
  type: typeof CREATE_DOMAIN_REQUEST;
  payload: {
    domainData: Partial<IDomain>;
    provider: 'aws' | 'mailgun';
  };
}

export interface CreateDomainSuccessAction {
  type: typeof CREATE_DOMAIN_SUCCESS;
  payload: IDomain;
}

export interface CreateDomainFailureAction {
  type: typeof CREATE_DOMAIN_FAILURE;
  payload: string;
}

export interface GetDomainRequestAction {
  type: typeof GET_DOMAIN_REQUEST;
  payload: string;
}

export interface GetDomainSuccessAction {
  type: typeof GET_DOMAIN_SUCCESS;
  payload: IDomain;
}

export interface GetDomainFailureAction {
  type: typeof GET_DOMAIN_FAILURE;
  payload: string;
}

export interface VerifyDomainPayload {
  domain: string;
  source?: 'domainRecords' | string;
  provider: 'aws' | 'mailgun';
}

export interface VerifyDomainRequestAction {
  type: typeof VERIFY_DOMAIN_REQUEST;
  payload: VerifyDomainPayload;
}

export interface VerifyDomainSuccessAction {
  type: typeof VERIFY_DOMAIN_SUCCESS;
  payload: IDomain;
}

export interface VerifyDomainFailureAction {
  type: typeof VERIFY_DOMAIN_FAILURE;
  payload: string;
}

export interface DeleteDomainRequestAction {
  type: typeof DELETE_DOMAIN_REQUEST;
  payload: {
    domainName: string;
    provider: 'aws' | 'mailgun';
  };
}

export interface DeleteDomainSuccessAction {
  type: typeof DELETE_DOMAIN_SUCCESS;
  payload: string;
}

export interface DeleteDomainFailureAction {
  type: typeof DELETE_DOMAIN_FAILURE;
  payload: string;
}

export interface ClearDomainStateAction {
  type: typeof CLEAR_DOMAIN_STATE;
  [key: string]: any;
}

export type DomainActionTypes =
  | GetDomainsRequestAction
  | GetDomainsSuccessAction
  | GetDomainsFailureAction
  | CreateDomainRequestAction
  | CreateDomainSuccessAction
  | CreateDomainFailureAction
  | GetDomainRequestAction
  | GetDomainSuccessAction
  | GetDomainFailureAction
  | VerifyDomainRequestAction
  | VerifyDomainSuccessAction
  | VerifyDomainFailureAction
  | DeleteDomainRequestAction
  | DeleteDomainSuccessAction
  | DeleteDomainFailureAction
  | ClearDomainStateAction;
